// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-tests-MFormDemoPage-MFormDemoPage-module__form--iDhCQ {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-pages-tests-MFormDemoPage-MFormDemoPage-module__tools--e8L0M {
  display: flex;
  gap: 10px;
}
/*# sourceMappingURL=MFormDemoPage.module.css.map */`, "",{"version":3,"sources":["webpack://./MFormDemoPage.module.less","webpack://./src/pages/tests/MFormDemoPage/MFormDemoPage.module.less"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;ACCF;ADEA;EACE,aAAA;EACA,SAAA;ACAF;AACA,mDAAmD","sourcesContent":[".form {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.tools {\n  display: flex;\n  gap: 10px;\n}\n",".form {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.tools {\n  display: flex;\n  gap: 10px;\n}\n/*# sourceMappingURL=MFormDemoPage.module.css.map */"],"sourceRoot":""}]);
// Exports
export var form = `src-pages-tests-MFormDemoPage-MFormDemoPage-module__form--iDhCQ`;
export var tools = `src-pages-tests-MFormDemoPage-MFormDemoPage-module__tools--e8L0M`;
export default ___CSS_LOADER_EXPORT___;
